import React from 'react';
import { Divider } from '@cube3/cubicle/src/core/atoms/Divider/Divider';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import { HelpIndicator } from '../../../main/src/components/app/layout/AppBar/HelpIndicator';
import { MediaQueueIndicator } from '../../../main/src/components/app/layout/MediaQueue/prefabs/MediaQueueIndicator';
import AccountStatusIndicator from '../../../main/src/components/app/layout//AppBar/AccountStatusIndicator';
import { StorageIndicator } from '../../../main/src/components/app/layout/NavigationDrawer/StorageIndicator';
import { isMobile } from 'react-device-detect';
import { MediaQueueContextProvider } from '../../../main/src/components/app/layout/MediaQueue/context/mediaQueueContext';

export interface NavContentProps {
  workspaceLogoComponent?: JSX.Element;
  extraSpaceLogo?: boolean;
  //
  searchComponent?: JSX.Element;
  //
  navigationComponent?: JSX.Element;
  //
  quickNavigationComponent?: React.ReactNode;
  /**we dont want to always display those 3 */
  showStorageIndicator?: boolean;
  showHelp?: boolean;
  showQueue?: boolean;
  showAccountIndicator?: boolean;
}

const useCSS = makeCSS(
  ({ theme, extraSpaceLogo }: NavContentProps & { theme }) => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between'
      },

      topSection: {
        flexShrink: 1,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      },
      workspaceLogoContainer: {
        width: extraSpaceLogo ? 192 : 96,
        height: theme.spacing[16],
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing[8],
        marginLeft: '5px'
      },
      navigation: {
        flexGrow: 1,
        flexShrink: 1,
        position: 'relative'
      },
      bottomSection: {
        display: 'inline-block',
        flexShrink: 0
      },
      dividerPad: {
        margin: '8px 0px'
      },
      account: {
        marginRight: theme.spacing[8]
      },
      storage: {
        width: '100%',
        bottom: '100%',
        left: 0,
        display: 'flex',
        flexDirection: 'column-reverse'
      }
    };
  }
);

export const NavContent = (props: NavContentProps) => {
  const {
    workspaceLogoComponent,
    searchComponent,
    navigationComponent,
    quickNavigationComponent,
    showStorageIndicator = false,
    showHelp = false,
    showQueue = false,
    showAccountIndicator = true
  } = props;
  const classes = useCSS(props);

  if (isMobile && quickNavigationComponent != undefined) {
    return <div>{quickNavigationComponent}</div>;
  }

  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.topSection}`}>
        {workspaceLogoComponent && (
          <div className={`${classes.workspaceLogoContainer}`}>
            {workspaceLogoComponent}
          </div>
        )}
        {searchComponent && (
          <div id="tour-steps__search">{searchComponent}</div>
        )}
        <div className={classes.navigation}>
          {navigationComponent && <>{navigationComponent}</>}
        </div>
      </div>

      <div className={`${classes.bottomSection}`}>
        {showStorageIndicator && (
          <>
            {isMobile && (
              <div className={`${classes.dividerPad}`}>
                <Divider color="line3" />
              </div>
            )}
            <div className={`${!isMobile ? classes.storage : ''}`}>
              <StorageIndicator />
            </div>
            {!isMobile && (
              <div className={`${classes.dividerPad}`}>
                <Divider color="line3" />
              </div>
            )}
          </>
        )}

        {showHelp && <HelpIndicator />}
        {showQueue && (
          <div id="tour-steps__media-queue">
            <MediaQueueContextProvider>
              <MediaQueueIndicator />
            </MediaQueueContextProvider>
          </div>
        )}

        {(showHelp || showQueue) && (
          <div className={`${classes.dividerPad}`}>
            <Divider color="line3" />
          </div>
        )}
        {showAccountIndicator && (
          <div className={`${classes.account}`}>
            <AccountStatusIndicator />
          </div>
        )}
      </div>
    </div>
  );
};
